import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmsets/cecUnmSets/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmsets/cecUnmSets/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmsets/cecUnmSets/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/unmsets/cecUnmSets/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmsets/cecUnmSets/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmsets/cecUnmSets/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmsets/cecUnmSets/import',
      method: 'post',
      data: data
    })
  },
  getCecProject: function (params) {
    return request({
      url: '/unmsets/cecUnmSets/getCecProject',
      method: 'post',
      params: params
    })
  },
  getCecProjectAndItem: function (params) {
    return request({
      url: '/unmsets/cecUnmSets/getCecProjectAndItem',
      method: 'post',
      params: params
    })
  }
}
